import { Station } from 'modules/institution-info/core/type';
import { Institution } from 'modules/institutions/core/type';

import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

interface State {
  isRefresh: boolean;
  institutionDetail: Institution | null;
  stations: Station[];
}

interface Store {
  state: State;
  setStations: (payload: Station[]) => void;
  setIsRefresh: (payload: boolean) => void;
  setInstitutionDetail: (payload: Institution | null) => void;
}

const initState: State = {
  stations: [],
  isRefresh: false,
  institutionDetail: null,
};

export const useStationStore = create(
  immer<Store>((set) => ({
    state: initState,
    setIsRefresh: (payload: boolean) => {
      set((store) => {
        store.state.isRefresh = payload;
      });
    },
    setStations: (stations: Station[]) => {
      set((store) => {
        store.state.stations = stations;
      });
    },
    setInstitutionDetail: (payload: Institution | null) => {
      set((store) => {
        store.state.institutionDetail = payload;
      });
    },
  })),
);

export const { setIsRefresh, setInstitutionDetail, setStations } = useStationStore.getState();

export const isRefreshSelector = (s: Store) => s.state.isRefresh;

export const institutionDetailSelector = (s: Store) => s.state.institutionDetail;
